import http from "../../http-common";

class FeedBackService {
    get(id, data) {
        return http.post(`/user/getFeedBack/${id}`, data);
    }
}

export default new FeedBackService();